import ResponsiveImage from '../../ResponsiveImage';

interface IImageProps {
  src: string;
}

export const Image: React.FC<IImageProps> = ({ src }) => {
  return (
    <div className="tw-mt-4 tw-flex tw-justify-center">
      <ResponsiveImage src={src} width={32} height={32} />
    </div>
  );
};
